import { createReducer } from '@reduxjs/toolkit'
import { DictT, SlotT } from 'types/model'
import { receiveSlots } from 'model/actions'

const initialState = {} as DictT<SlotT>

const reducer = createReducer(initialState, builder => {
  builder.addCase(receiveSlots, (state, action) => action.payload)
})

export default reducer
